module.exports = __webpack_public_path__ + "b2ea558e08fd651231dee1c35d0268d0.webp";